import { render, staticRenderFns } from "./LocaleFlag.vue?vue&type=template&id=1ab81a61&"
import script from "./LocaleFlag.vue?vue&type=script&lang=js&"
export * from "./LocaleFlag.vue?vue&type=script&lang=js&"
import style0 from "./LocaleFlag.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports